import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CrossButton, FloatingVideo, FullScreenVideoContainer } from './styled';
import { images } from '../../Constants/ImageUrls';

import VideoComponent from './VideoComponent/index';
import Cookies from 'js-cookie';
import { fireEvent } from '../../Utils/fireEvent';

export default function index({
  multipleVideos,
  hasStickyStrip,
  isForLactoPage,
  setIsFullScreenVideoEnabled,
  fromPdp,
  isCartOpen,
  currentVideoIndex,
  showFullScreenVideo,
  setShowFullScreenVideo,
  setCurrentVideoIndex,
}) {
  const videoRef = useRef(null);

  const filterVideosByZone = (multipleVideos) => {
    const zone = Cookies.get('zone');
    const videos = zone
      ? [
          ...multipleVideos.filter((obj) => obj.regionEligible == zone),
          ...multipleVideos.filter((obj) => obj.regionEligible == 'All'),
        ]
      : multipleVideos?.filter((obj) => obj.regionEligible == 'All');
    return videos;
  };

  const filteredVideos = filterVideosByZone(multipleVideos);

  const [showFloatingVideo, setShowFloatingVideo] = useState(true);
  const [remainingHeight, setRemainingHeight] = useState(0);
  const touchStartY = useRef(0);
  const containerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isScrolling, setIsScrolling] = useState(false);
  const touchActive = useRef(false);
  const [reels, setReels] = useState(filteredVideos);

  const openFullScreen = () => {
    setShowFullScreenVideo(true);
    setIsFullScreenVideoEnabled(true);
    setReels(filteredVideos);
    fireEvent({
      category: 'clicked_floating_video',
    });
  };

  const handleCloseFloatingVideo = () => {
    setShowFloatingVideo(false);
  };

  useEffect(() => {
    fireEvent({
      category: 'viewed_floating_video',
    });
    const handleResize = () => {
      setRemainingHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    setReels(filteredVideos.slice(currentVideoIndex));
  }, [Cookies.get('zone'), currentVideoIndex]);

  const handleWheel = useCallback(
    (event) => {
      if (isScrolling) return;

      const delta = event.deltaY;
      const nextIndex = delta > 0 ? currentIndex + 1 : currentIndex - 1;

      if (nextIndex >= 0 && nextIndex < reels.length) {
        setIsScrolling(true);
        setCurrentIndex(nextIndex);

        const container = containerRef.current;
        const childHeight = container.firstChild.offsetHeight;

        container.scrollTo({
          top: nextIndex * childHeight,
          behavior: 'auto',
        });

        setTimeout(() => {
          setIsScrolling(false);
        }, 100);
      } else if (nextIndex >= reels.length) {
        setReels((prevReels) => [...prevReels, ...filteredVideos]);
      }
    },
    [currentIndex, isScrolling, reels.length],
  );

  const handleTouchStart = (event) => {
    touchStartY.current = event.touches[0].clientY;
    touchActive.current = true;
  };

  const handleTouchMove = (event) => {
    event.preventDefault();
    if (isScrolling || !touchActive.current) return;
    const touchEndY = event.touches[0].clientY;
    const touchDiff = touchStartY.current - touchEndY;

    if (Math.abs(touchDiff) > 50) {
      const nextIndex = touchDiff > 0 ? currentIndex + 1 : currentIndex - 1;

      if (nextIndex >= 0 && nextIndex < reels.length) {
        setIsScrolling(true);
        setCurrentIndex(nextIndex);

        const container = containerRef.current;
        const childHeight = container.firstChild.offsetHeight;

        container.scrollTo({
          top: nextIndex * childHeight,
          behavior: 'auto',
        });

        setTimeout(() => {
          setIsScrolling(false);
          touchActive.current = false;
        }, 100);
      } else if (nextIndex >= reels.length) {
        setReels((prevReels) => [...prevReels, ...filteredVideos]);
      }
    }
  };

  const handleTouchEnd = () => {
    touchActive.current = false;
  };

  useEffect(() => {
    if (containerRef.current) {
      const container = containerRef.current;
      container.addEventListener('wheel', handleWheel, {
        passive: false,
      });
      container.addEventListener('touchstart', handleTouchStart, {
        passive: false,
      });
      container.addEventListener('touchmove', handleTouchMove, {
        passive: false,
      });
      container.addEventListener('touchend', handleTouchEnd, {
        passive: false,
      });

      return () => {
        container.removeEventListener('wheel', handleWheel);
        container.removeEventListener('touchstart', handleTouchStart);
        container.removeEventListener('touchmove', handleTouchMove);
        container.removeEventListener('touchend', handleTouchEnd);
      };
    }
  }, [handleWheel, handleTouchStart, handleTouchMove, handleTouchEnd]);

  return (
    <>
      {showFloatingVideo ? (
        showFullScreenVideo ? (
          <FullScreenVideoContainer
            ref={containerRef}
            remainingHeight={remainingHeight}
            onWheel={handleWheel}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            {reels?.map((videoData, index) => {
              return (
                <VideoComponent
                  key={index}
                  videoData={videoData}
                  setShowFullScreenVideo={setShowFullScreenVideo}
                  setIsFullScreenVideoEnabled={setIsFullScreenVideoEnabled}
                  autoPlay={index === 0}
                  remainingHeight={remainingHeight}
                  isCartOpen={isCartOpen}
                  setCurrentVideoIndex={setCurrentVideoIndex}
                  setCurrentIndex={setCurrentIndex}
                />
              );
            })}
          </FullScreenVideoContainer>
        ) : (
          <FloatingVideo
            hasStickyStrip={hasStickyStrip}
            isForLactoPage={isForLactoPage}
            fromPdp={fromPdp}
          >
            <CrossButton onClick={handleCloseFloatingVideo}>
              <img
                src={images.CrossWhite}
                width={17}
                height={17}
                alt="dismiss video"
              />
            </CrossButton>
            <video
              muted
              ref={videoRef}
              autoPlay
              loop
              onClick={openFullScreen}
              preload="auto"
              playsInline
              width={90}
              height={160}
            >
              <source src={reels[0].url} />
            </video>
            {reels[0].viewCount || reels[0].views ? (
              <div className="viewCount">
                <img
                  src="https://images.myloapp.in/NestJsUploads/1720595560968-View-count.webp"
                  alt=""
                />
                {reels[0].viewCount || reels[0].views}
              </div>
            ) : null}
          </FloatingVideo>
        )
      ) : null}
    </>
  );
}
